const setPageTitle = text => {
  document.title = `${text} - Pleteo`;
};

export default setPageTitle;
